/**
 * @file index.tsx
 *
 * @fileoverview Renders a landing page Quote paragraph type.
 */

import React from 'react';
import { LpQuoteParagraph } from '~/jobiqo/types/types';
import styles from './lpQuote.module.scss';
import Image from '~/jobiqo/components/Image';
import { Quote } from '~/vcl/molecules/14-quote';
import { FlexItems } from '~/vcl/atoms/06-layout/03-flex';
import { useIsMobile } from '~/vcl/hooks/useIsMobile';

interface LpQuoteProps {
  /**
   * The landing page quota paragraph.
   */
  card: LpQuoteParagraph;
}

export const LpQuote = ({ card }: LpQuoteProps) => {
  return (
    <FlexItems
      justifyContent="center"
      className={`${styles.lpQuoteWrapper} jd-lp-quote-wrapper`}
    >
      <Quote
        text={card.text}
        author={card.author ?? undefined}
        {...(card.image && {
          Image: (
            <div
              className={`${styles.imageWrapper} ${
                useIsMobile() ? styles.imageWrapperMobile : ''
              }`}
            >
              <Image
                src={card.image.url}
                alt={card.image.alt ?? ''}
                {...(card.image.title && { title: card.image.title })}
                width={null}
                height={null}
              />
            </div>
          ),
        })}
      />
    </FlexItems>
  );
};

export default LpQuote;
